import Table from "../components/Table";
import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useRef, useState } from "react";
import $ from "jquery";
import config from "../../../config";
import Pagination from "../../../components/Pagination";
import "../style.css";
import Swal from "sweetalert2";
import Tippy from "@tippyjs/react";
import filterIcon from "../../../images/icons/filter.png";
import excelIcon from "../../../images/icons/excel 1 (1).png";
import Filter from "../components/Filter";
import ExcelDownload from "../components/ExcelDownload";
import moment from "moment";
import axios from "axios";
import { millionComma } from "../../../utils";

const getItemList = async (inputValue, callback) => {
  if (inputValue.toString().length > 2) {
    await $.post(
      `${config.apiUrl}/item/listItem`,
      JSON.stringify({
        is_active: 1,
        paginate: 0,
        item_name: inputValue.toString(),
      }),
      function (res) {
        callback(
          res.data.list.map((v) => {
            return {
              value: v.item_id,
              label: v.item_name,
            };
          })
        );
      }
    );
  } else {
    callback([]);
  }
};

const getItemCatList = async (inputValue, callback) => {
  if (inputValue.toString().length > 2) {
    await $.post(
      `${config.apiUrl}/itemCategory/listItemCategory`,
      JSON.stringify({
        is_active: 1,
        paginate: 0,
        item_cat_name: inputValue.toString(),
      }),
      function (res) {
        callback(
          res.data.list.map((v) => {
            return {
              value: v.item_cat_id,
              label: v.item_cat_name,
            };
          })
        );
      }
    );
  } else {
    callback([]);
  }
};

const StockSummary = () => {
  const [user, setUser] = useState({});
  const [pageSize, setPageSize] = useState(10);
  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);
  const getGodownList = async (inputValue, callback) => {
    await $.post(
      `${config.apiUrl}/godown/listGodown`,
      JSON.stringify({
        godown_name: inputValue,
        paginate: 0,
        is_active: 1,
        // branch_id: filter.branch_id,
        branch_id:
          filter.branch_id ||
          JSON.parse(localStorage.getItem("inventory"))?.userData
            ?.branch_data?.[0]?.branch_id,
      }),
      function (res) {
        if (res?.data?.count) {
          callback(
            res.data.list.map((v) => {
              return {
                value: v.godown_id,
                label: v.godown_name,
              };
            })
          );
        } else {
          callback([]);
        }
      }
    );
  };
  const isMounted = useRef(false);
  const [isCheckedMovement, setIsCheckedMovement] = useState(true);
  const [isCheckedDatewise, setIsCheckedDatewise] = useState(false);
  const filterList = [
    {
      name: "item_id",
      label: "Item Name",
      type: "async_select",
      values: getItemList,
    },
    { name: "movement", label: "Movement", type: "checkbox" },
    { name: "date_wise", label: "Date-Wise", type: "checkbox" },
    {
      name: "godown_id",
      label: "Godown Name",
      type: "async_select",
      values: getGodownList,
    },
    {
      name: "item_cat_id",
      label: "Category",
      type: "async_select",
      values: getItemCatList,
    },
    { name: "from_date", label: "From Date", type: "date", required: "true" },
    { name: "to_date", label: "To Date", type: "date", required: "true" },
  ];

  const columnList = [
    // {label: "ID", value: "item_summary_id", visible: true},
    // {
    //   label: "Branch",
    //   value: "branch_name",
    //   visible: [1, 2].includes(user.role_id),
    // },
    // trans_date
    {
      label: "Date",
      value: "trans_date",
      visible: isCheckedDatewise ? true : false,
    },
    { label: "Godown", value: "godown_name", visible: true },
    { label: "Item", value: "item_name", visible: true },
    { label: "Category", value: "item_cat_name", visible: true },
    { label: "Unit", value: "item_unit", visible: true },
    { label: "Op. Qty ", value: "op_st", visible: true },
    // { label: "Op. Qty", value: "op_st", visible: true },

    { label: "Purchase", value: "pur", visible: true },
    { label: "Challan", value: "sales", visible: true },
    { label: "Purchase Rtn", value: "pur_rtn", visible: true },
    { label: "Challan Rtn", value: "sales_rtn", visible: true },
    { label: "Adjust In", value: "adjustment_in", visible: true },
    { label: "Adjust Out", value: "adjustment_out", visible: true },
    { label: "Cl. Qty", value: "cl_st", visible: true },
  ];

  // const [filter, setFilter] = useState(() => {
  //   let filters = {};
  //   filterList.forEach((list) => {
  //     if (list.name === "from_date" || list.name === "to_date") {
  //       filters[list.name] = moment().format("YYYY-MM-DD");
  //     } else if (list.name === "movement") {
  //       filters[list.name] = true;
  //     } else {
  //       filters[list.name] = "";
  //     }
  //   });
  //   return filters;
  // });

  const [filter, setFilter] = useState(() => {
    let filters = {};
    filterList.forEach((list) => {
      if (list.name === "from_date" || list.name === "to_date") {
        filters[list.name] = moment().format("YYYY-MM-DD");
      } else if (list.name === "movement") {
        filters[list.name] = isCheckedMovement ? 1 : 0;
      } else if (list.name === "date_wise") {
        filters[list.name] = isCheckedDatewise ? 1 : 0;
      } else {
        filters[list.name] = "";
      }
    });
    return filters;
  });
  const [column, setColumn] = useState(() => columnList);
  useEffect(() => {
    setColumn(() => columnList);
  }, [user, isCheckedDatewise]);

  console.log("columnList", columnList);
  const [row, setRow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [showFilter, setShowFilter] = useState(true);
  const [showLoading, setShowLoading] = useState(false);

  const getList = async () => {
    if (!filter?.from_date || !filter?.to_date) {
      Swal.fire("Error", "Date is Required");
      return;
    }
    if (filter.date_wise == 1 && !filter.item_id) {
      Swal.fire("Error", "Item is Required when Datewise is checked");
      return;
    }
    setShowLoading(true);
    await $.post(
      `${config.apiUrl}/report/listStockSummary`,
      JSON.stringify({
        ...filter,
        paginate: 1,
        is_active: 1,
        page_no: currentPage - 1,
        page_size: pageSize,
        branch_id: JSON.parse(localStorage.getItem("inventory"))?.userData
          ?.branch_data?.[0]?.branch_id,
      })
    )
      .done((res) => {
        if (res?.data?.list?.length > 0) {
          let cols = columnList.map((col) => col.value);
          setRow(() => {
            let resArr = res?.data?.list || [];
            return resArr.map((r) => ({
              trans_date:
                (r?.trans_date
                  ? moment(r?.trans_date).format("DD-MM-YYYY")
                  : "") || "",
              item_summary_id: r?.item_summary_id || "",
              branch_name: r?.branch_name || "",
              godown_name: r?.godown_name || "",
              item_name: r?.item_name || "",
              item_cat_name: r?.item_cat_name || "",
              item_unit: r?.item_unit || "-",
              // op_st: `${millionComma(r?.op_st || 0)} (${millionComma(
              //     (r?.op_st - r?.challan_qty_op) || 0
              // )})`,
              op_st: `${millionComma(r?.op_st || 0)}`,
              pur: millionComma(r?.pur || 0),
              sales: `${millionComma(r?.sales || 0)} (${millionComma(
                r?.challan_qty || 0
              )})`,
              sales: `${millionComma(r?.sales || 0)}`,
              pur_rtn: millionComma(r?.pur_rtn || 0),
              sales_rtn: millionComma(r?.sales_rtn || 0),
              adjustment_in: millionComma(r?.adjustment_in || 0),
              adjustment_out: millionComma(r?.adjustment_out || 0),
              // cl_st: `${millionComma(r?.cl_st || 0)} (${millionComma(
              //     (r?.cl_st - r?.challan_qty_op - r?.challan_qty_cl) || 0
              // )})`,
              cl_st: `${millionComma(r?.cl_st || 0)}`,
              godown_id: r?.godown_id || "",
              item_id: r?.item_id || "",
            }));
          });
          setTotalPage(() => res?.data?.count || 0);
          setCurrentPage(() => currentPage);
        } else {
          setTotalPage(() => 0);
          setCurrentPage(() => 1);
          setRow(() => []);
        }
        setShowLoading(false);
      })
      .fail((err) => {
        Swal.fire(
          "",
          err?.responseJSON?.data?.message || err?.responseJSON?.message
        );
        setShowLoading(false);
      });
  };

  const clearList = () => {
    setFilter(() => {
      let filters = {};
      filterList.forEach((list) => {
        filters[list.name] = "";
      });
      return filters;
    });
    setTotalPage(() => 0);
    setCurrentPage(() => 1);
    setRow(() => []);
    setIsCheckedMovement(false);
    setIsCheckedDatewise(false);
  };

  useEffect(() => {
    if (isMounted.current) getList();
    isMounted.current = true;
  }, [currentPage]);

  const validateDownload = (filter) => {
    if (!filter?.from_date || !filter?.to_date) {
      Swal.fire("Error", "Date is Required");
      return false;
    }

    return true;
  };
  // const changePageSize = async (e) => {
  //     setPageSize(() => e.target.value);

  //     if (row.length > 0) {
  //         currentPage == 1
  //             ? await getList({
  //                 ...filter,
  //                 page_size: e.target.value,
  //             })
  //             : setCurrentPage(() => 1);
  //     }
  // };
  const changePageSize = (e) => {
    const newSize = e.target.value;
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (row.length > 0) {
      getList();
    }
  }, [pageSize]);

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />
          <main className="bg-white rounded-2" id="ledger">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col-md">
                  <Breadcrumb path={["Stock Summary"]} />
                </div>

                <div className="col-md text-end">
                  <select value={pageSize} onChange={(e) => changePageSize(e)}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <Tippy content="Filter" trigger="mouseenter">
                    <img
                      src={filterIcon}
                      className="img-fluid mx-2 icon"
                      width="35px"
                      height="35px"
                      alt=""
                      role="button"
                      onClick={(e) => setShowFilter(!showFilter)}
                    />
                  </Tippy>

                  <ExcelDownload
                    validate={validateDownload}
                    filter={filter}
                    filename="StockSummary"
                    url={`${config.apiUrl}/report/listStockSummary`}
                  />
                </div>
              </div>

              <Filter
                show={showFilter}
                filterList={filterList}
                showLoading={showLoading}
                filter={filter}
                handler={{
                  getList,
                  clearList,
                  state: { filter, setFilter },
                  //   checkedBox: { setIsCheckedMovement, isCheckedMovement },
                  checkedBox: {
                    movement: {
                      isChecked: isCheckedMovement,
                      setIsChecked: setIsCheckedMovement,
                    },
                    date_wise: {
                      isChecked: isCheckedDatewise,
                      setIsChecked: setIsCheckedDatewise,
                    },
                  },
                }}
              />

              <Table
                tableData={{ column, row }}
                handler={{ getList }}
                filter={filter}
              />

              <div className="row  mt-4">
                <div className="col">
                  <Pagination
                    // nPages={Math.ceil(totalPage / 10)}
                    nPages={Math.ceil(totalPage / Number(pageSize))}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default StockSummary;
